"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeoJSON = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_cirrus_store_1 = require("@yanzi/react-cirrus-store");
const react_maps_1 = require("@yanzi/react-maps");
const react_ui_1 = require("@yanzi/react-ui");
const react_1 = __importStar(require("react"));
exports.GeoJSON = react_1.memo(function GeoJSON(_a) {
    var { baseUrl, layer, hideGeoJsonForImageFloorPlans, opacity, renderFeature, zIndex, selectedFeatures, onSelectedFeaturesChange } = _a, props = __rest(_a, ["baseUrl", "layer", "hideGeoJsonForImageFloorPlans", "opacity", "renderFeature", "zIndex", "selectedFeatures", "onSelectedFeaturesChange"]);
    const { data: geoJson, loading } = react_cirrus_store_1.useCirrusStoreGet(`${baseUrl}/${layer.src}`);
    if (!geoJson) {
        return loading ? jsx_runtime_1.jsx(react_ui_1.BarLoader, { color: "#999" }, void 0) : null;
    }
    if (hideGeoJsonForImageFloorPlans && layer.generatedFromAssets) {
        return null;
    }
    const featureOpacity = layer.generatedFromAssets
        ? 0.5 * (opacity === undefined ? 1 : opacity)
        : layer.opacity !== undefined
            ? layer.opacity * (opacity === undefined ? 1 : opacity)
            : opacity;
    return (jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: geoJson.features.map((feature, i) => {
            const isSelected = selectedFeatures === null || selectedFeatures === void 0 ? void 0 : selectedFeatures.includes(feature.id);
            const order = i / geoJson.features.length;
            const allProps = Object.assign(Object.assign({ renderMode: 'image' }, props), { zIndex: zIndex !== undefined ? zIndex + order : order, opacity: featureOpacity, isSelected, onSelect: () => onSelectedFeaturesChange === null || onSelectedFeaturesChange === void 0 ? void 0 : onSelectedFeaturesChange(old => [...old, feature.id]), onDeselect: () => onSelectedFeaturesChange === null || onSelectedFeaturesChange === void 0 ? void 0 : onSelectedFeaturesChange(old => old.filter(x => x !== feature.id)) });
            if (!renderFeature) {
                return (jsx_runtime_1.jsx(react_1.default.Fragment, { children: jsx_runtime_1.jsx(react_maps_1.GeoJSONFeature, Object.assign({ feature: feature }, allProps), feature.id) }, feature.id));
            }
            const representation = renderFeature({
                props: allProps,
                feature,
            });
            return jsx_runtime_1.jsx(react_1.default.Fragment, { children: representation }, feature.id);
        }) }, void 0));
});
//# sourceMappingURL=GeoJSON.js.map